// @ts-nocheck
import type { Question } from '../types';

export const roadMarkingsQuestions: Question[] = [
  {
    id: 'q-rm-1',
    topic: 'General',
    question: 'What does a solid white line in the center of the road indicate?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-1-solid-white-line.jpg',
    options: [
      { id: 'q-rm-1o1', text: 'You can overtake if safe' },
      { id: 'q-rm-1o2', text: 'No overtaking allowed' },
      { id: 'q-rm-1o3', text: 'Overtaking allowed only for motorcycles' },
      { id: 'q-rm-1o4', text: 'Overtaking allowed only during daylight' }
    ],
    answerId: 'q-rm-1o2',
    explanation: 'A solid white line in the center of the road indicates that overtaking is not allowed. You must stay in your lane. (RVV 1990 art. 82)',
    subject: 'Road Markings'
  },
  {
    id: 'q-rm-2',
    topic: 'General',
    question: 'What does a broken white line in the center of the road indicate?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-2-broken-white-line.jpg',
    options: [
      { id: 'q-rm-2o1', text: 'No overtaking allowed' },
      { id: 'q-rm-2o2', text: 'Overtaking allowed if safe' },
      { id: 'q-rm-2o3', text: 'Overtaking allowed only for emergency vehicles' },
      { id: 'q-rm-2o4', text: 'Overtaking allowed only on the left' }
    ],
    answerId: 'q-rm-2o2',
    explanation: 'A broken white line indicates that overtaking is allowed if it is safe to do so and there is sufficient visibility.',
    subject: 'Road Markings'
  },
  {
    id: 'q-rm-3',
    topic: 'General',
    question: 'What does a yellow line along the edge of the road indicate?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-3-yellow-edge-line.jpg',
    options: [
      { id: 'q-rm-3o1', text: 'No parking allowed' },
      { id: 'q-rm-3o2', text: 'Parking allowed for 30 minutes' },
      { id: 'q-rm-3o3', text: 'Parking allowed for residents only' },
      { id: 'q-rm-3o4', text: 'Parking allowed during certain hours' }
    ],
    answerId: 'q-rm-3o1',
    explanation: 'A yellow line along the edge of the road indicates that parking is not allowed at any time.',
    subject: 'Road Markings'
  },
  {
    id: 'q-rm-4',
    topic: 'General',
    question: 'What does a blue line along the edge of the road indicate?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-4-blue-disabled-parking.jpg',
    options: [
      { id: 'q-rm-4o1', text: 'No parking allowed' },
      { id: 'q-rm-4o2', text: 'Parking for disabled persons only' },
      { id: 'q-rm-4o3', text: 'Parking for residents only' },
      { id: 'q-rm-4o4', text: 'Parking with a permit only' }
    ],
    answerId: 'q-rm-4o2',
    explanation: 'A blue line indicates parking reserved for disabled persons. You must have a valid disabled parking permit to park here.',
    subject: 'Road Markings'
  },
  {
    id: 'q-rm-5',
    topic: 'General',
    question: 'What does a zigzag line on the road indicate?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-5-zigzag-pedestrian.jpg',
    options: [
      { id: 'q-rm-5o1', text: 'A pedestrian crossing' },
      { id: 'q-rm-5o2', text: 'A bus stop' },
      { id: 'q-rm-5o3', text: 'A school zone' },
      { id: 'q-rm-5o4', text: 'A construction zone' }
    ],
    answerId: 'q-rm-5o1',
    explanation: 'Zigzag lines indicate a pedestrian crossing. You must not park or overtake in this area.',
    subject: 'Road Markings'
  },
  {
    id: 'q-rm-6',
    topic: 'General',
    question: 'What does a white arrow pointing straight ahead on the road indicate?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-6-arrow-straight.jpg',
    options: [
      { id: 'q-rm-6o1', text: 'You must turn left' },
      { id: 'q-rm-6o2', text: 'You must turn right' },
      { id: 'q-rm-6o3', text: 'You must go straight ahead' },
      { id: 'q-rm-6o4', text: 'You can choose any direction' }
    ],
    answerId: 'q-rm-6o3',
    explanation: 'A white arrow pointing straight ahead indicates that you must proceed in that direction.',
    subject: 'Road Markings'
  },
  {
    id: 'q-rm-7',
    topic: 'General',
    question: 'What does a white bicycle symbol on the road indicate?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-7-bicycle-symbol.jpg',
    options: [
      { id: 'q-rm-7o1', text: 'A bicycle lane' },
      { id: 'q-rm-7o2', text: 'A bicycle crossing' },
      { id: 'q-rm-7o3', text: 'A bicycle parking area' },
      { id: 'q-rm-7o4', text: 'A bicycle repair shop' }
    ],
    answerId: 'q-rm-7o1',
    explanation: 'A white bicycle symbol indicates a bicycle lane. Motor vehicles should not drive in this lane.',
    subject: 'Road Markings'
  },
  {
    id: 'q-rm-8',
    topic: 'General',
    question: 'What does a white "STOP" word painted on the road indicate?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-8-stop-text.jpg',
    options: [
      { id: 'q-rm-8o1', text: 'You must slow down' },
      { id: 'q-rm-8o2', text: 'You must stop completely' },
      { id: 'q-rm-8o3', text: 'You must yield to pedestrians' },
      { id: 'q-rm-8o4', text: 'You must honk your horn' }
    ],
    answerId: 'q-rm-8o2',
    explanation: 'A white "STOP" word painted on the road reinforces the requirement to stop completely at the stop line or before entering the intersection. (RVV 1990 art. 82)',
    subject: 'Road Markings'
  },
  {
    id: 'q-rm-9',
    topic: 'General',
    question: 'What does a white diamond symbol on the road indicate?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-9-diamond-priority.jpg',
    options: [
      { id: 'q-rm-9o1', text: 'A priority road' },
      { id: 'q-rm-9o2', text: 'A school zone' },
      { id: 'q-rm-9o3', text: 'A construction zone' },
      { id: 'q-rm-9o4', text: 'A parking zone' }
    ],
    answerId: 'q-rm-9o1',
    explanation: 'A white diamond symbol indicates a priority road. Traffic on this road has the right of way over traffic entering from side roads.',
    subject: 'Road Markings'
  },
  {
    id: 'q-rm-10',
    topic: 'General',
    question: 'What does a white "GIVE WAY" text painted on the road indicate?',
    options: [
      { id: 'q-rm-10o1', text: 'You must stop completely' },
      { id: 'q-rm-10o2', text: 'You must yield to other traffic' },
      { id: 'q-rm-10o3', text: 'You must honk your horn' },
      { id: 'q-rm-10o4', text: 'You must slow down only' }
    ],
    answerId: 'q-rm-10o2',
    explanation: 'A white "GIVE WAY" text reinforces the requirement to yield to other traffic before proceeding.',
    subject: 'Road Markings'
  },
  {
    id: 'q-rm-11',
    topic: 'General',
    question: 'What does a white "BUS" text painted on the road indicate?',
    options: [
      { id: 'q-rm-11o1', text: 'A bus lane' },
      { id: 'q-rm-11o2', text: 'A bus stop' },
      { id: 'q-rm-11o3', text: 'A bus parking area' },
      { id: 'q-rm-11o4', text: 'A bus terminal' }
    ],
    answerId: 'q-rm-11o1',
    explanation: 'A white "BUS" text indicates a bus lane. Only buses and authorized vehicles may use this lane.',
    subject: 'Road Markings'
  },
  {
    id: 'q-rm-12',
    topic: 'General',
    question: 'What does a white "TAXI" text painted on the road indicate?',
    options: [
      { id: 'q-rm-12o1', text: 'A taxi lane' },
      { id: 'q-rm-12o2', text: 'A taxi stand' },
      { id: 'q-rm-12o3', text: 'A taxi parking area' },
      { id: 'q-rm-12o4', text: 'A taxi office' }
    ],
    answerId: 'q-rm-12o1',
    explanation: 'A white "TAXI" text indicates a taxi lane. Only taxis and authorized vehicles may use this lane.',
    subject: 'Road Markings'
  },
  {
    id: 'q-rm-13',
    topic: 'General',
    question: 'What does a double solid white line in the center of the road indicate?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-13-double-solid-line.jpg',
    options: [
      { id: 'q-rm-13o1', text: 'Overtaking allowed if safe' },
      { id: 'q-rm-13o2', text: 'No overtaking in either direction' },
      { id: 'q-rm-13o3', text: 'Overtaking allowed only on the left' },
      { id: 'q-rm-13o4', text: 'Overtaking allowed at night only' }
    ],
    answerId: 'q-rm-13o2',
    explanation: 'A double solid white line means you must not cross it to overtake. No overtaking in either direction. (RVV 1990 art. 82)',
    subject: 'Road Markings'
  },
  {
    id: 'q-rm-14',
    topic: 'General',
    question: 'What does a yellow box with criss-cross markings on the road indicate?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-14-yellow-box-junction.jpg',
    options: [
      { id: 'q-rm-14o1', text: 'You may wait here in traffic' },
      { id: 'q-rm-14o2', text: 'You must not enter unless your exit is clear' },
      { id: 'q-rm-14o3', text: 'Parking allowed for 5 minutes' },
      { id: 'q-rm-14o4', text: 'Loading zone' }
    ],
    answerId: 'q-rm-14o2',
    explanation: 'A yellow box (box junction) means you must not enter it unless your exit road or lane is clear. You may only enter to turn right if you are not blocking other traffic.',
    subject: 'Road Markings'
  },
  {
    id: 'q-rm-15',
    topic: 'General',
    question: 'What does a broken yellow line along the edge of the road indicate?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-15-broken-yellow-line.jpg',
    options: [
      { id: 'q-rm-15o1', text: 'No parking at any time' },
      { id: 'q-rm-15o2', text: 'No stopping; parking may be restricted to certain times' },
      { id: 'q-rm-15o3', text: 'Parking for residents only' },
      { id: 'q-rm-15o4', text: 'Parking allowed for 30 minutes' }
    ],
    answerId: 'q-rm-15o2',
    explanation: 'A broken (dashed) yellow line often indicates no stopping or restricted parking. Check local signs for exact rules.',
    subject: 'Road Markings'
  },
  {
    id: 'q-rm-16',
    topic: 'General',
    question: 'What does a white triangle painted on the road at a junction usually indicate?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-16-white-triangle.jpg',
    options: [
      { id: 'q-rm-16o1', text: 'You have priority' },
      { id: 'q-rm-16o2', text: 'Give way to traffic on the main road' },
      { id: 'q-rm-16o3', text: 'Speed bump ahead' },
      { id: 'q-rm-16o4', text: 'Pedestrian crossing ahead' }
    ],
    answerId: 'q-rm-16o2',
    explanation: 'A white triangle (often with a give way sign) indicates you must give way to traffic on the main road.',
    subject: 'Road Markings'
  },
  {
    id: 'q-rm-17',
    topic: 'General',
    question: 'What do white diagonal stripes in a lane indicate?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-17-diagonal-stripes.jpg',
    options: [
      { id: 'q-rm-17o1', text: 'Overtaking allowed' },
      { id: 'q-rm-17o2', text: 'You must not drive on them; they separate traffic or protect a turn' },
      { id: 'q-rm-17o3', text: 'Parking allowed' },
      { id: 'q-rm-17o4', text: 'Cycle lane' }
    ],
    answerId: 'q-rm-17o2',
    explanation: 'White diagonal stripes (hatched area) mark a zone you must not enter unless necessary. They separate traffic flows or protect a turning area.',
    subject: 'Road Markings'
  },
  {
    id: 'q-rm-18',
    topic: 'General',
    question: 'What does a white "30" in a circle on the road indicate?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-18-speed-limit-30.jpg',
    options: [
      { id: 'q-rm-18o1', text: '30 km/h speed limit' },
      { id: 'q-rm-18o2', text: 'Zone 30 starts here' },
      { id: 'q-rm-18o3', text: 'Parking for 30 minutes' },
      { id: 'q-rm-18o4', text: 'Distance 30 m to junction' }
    ],
    answerId: 'q-rm-18o1',
    explanation: 'A speed limit painted on the road (e.g. 30 in a circle) indicates the maximum speed limit for that road.',
    subject: 'Road Markings'
  },
  {
    id: 'q-rm-19',
    topic: 'General',
    question: 'What does a solid white line across your lane at a junction indicate?',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/road-markings/q-rm-19-stop-line.jpg',
    options: [
      { id: 'q-rm-19o1', text: 'Recommended stopping point' },
      { id: 'q-rm-19o2', text: 'Stop line; you must stop before it if required' },
      { id: 'q-rm-19o3', text: 'Cycle crossing' },
      { id: 'q-rm-19o4', text: 'Parking boundary' }
    ],
    answerId: 'q-rm-19o2',
    explanation: 'A solid white line across the lane is a stop line. You must stop before it when required (e.g. at a red light or stop sign). (RVV 1990 art. 82)',
    subject: 'Road Markings'
  },
  {
    id: 'q-rm-20',
    topic: 'General',
    question: 'What does a white "P" with a line through it on the road indicate?',
    options: [
      { id: 'q-rm-20o1', text: 'Parking allowed' },
      { id: 'q-rm-20o2', text: 'No parking' },
      { id: 'q-rm-20o3', text: 'Parking for permit holders only' },
      { id: 'q-rm-20o4', text: 'Paid parking' }
    ],
    answerId: 'q-rm-20o2',
    explanation: 'A "P" with a line through it or a similar marking indicates no parking. Do not park in that area.',
    subject: 'Road Markings'
  }
];
